// removed by extract-text-webpack-plugin
module.exports = {"elder-mode":"elder-mode","elder-mode-component-ignore":"elder-mode-component-ignore","elder-mode-image-only":"elder-mode-image-only","linchen-imgwrap":"linchen-imgwrap","cover":"cover"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/elderMode.less
// module id = 644
// module chunks = 438